import { GET_QUERIES } from "./queries.constants";

export const getQueries = (payload, callback) => ({type: GET_QUERIES, payload, callback})